export default __webpack_public_path__ + "static/media/hero-background.a51da13f.png";